define(["require", "exports", "tslib", "./ServiceBase"], function (require, exports, tslib_1, ServiceBase_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ServiceTransport = void 0;
    var ServiceTransport = (function (_super) {
        (0, tslib_1.__extends)(ServiceTransport, _super);
        function ServiceTransport(channelFlag) {
            if (channelFlag === void 0) { channelFlag = ''; }
            return _super.call(this, channelFlag) || this;
        }
        ServiceTransport.prototype.transportConfig = function (url, config) {
            if (config && config.params) {
                return config;
            }
            if (config) {
                return { params: config };
            }
            return { params: {} };
        };
        ServiceTransport.prototype.getCustomParams = function (url, config) {
            if (config && config.params) {
                return (0, tslib_1.__assign)({}, config.params);
            }
            return {};
        };
        ServiceTransport.prototype.get = function (url, config) {
            if (config === void 0) { config = {}; }
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var resultData;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.executeGet(url, config)];
                        case 1:
                            resultData = _a.sent();
                            if (resultData && resultData.data) {
                                return [2, resultData.data];
                            }
                            return [2, resultData];
                    }
                });
            });
        };
        ServiceTransport.prototype.post = function (url, data, config) {
            if (config === void 0) { config = {}; }
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var resultData;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.executePost(url, data, config)];
                        case 1:
                            resultData = _a.sent();
                            if (resultData && resultData.data) {
                                return [2, resultData.data];
                            }
                            return [2, resultData];
                    }
                });
            });
        };
        ServiceTransport.prototype.delete = function (url, config) {
            if (config === void 0) { config = {}; }
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var resultData;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.executeDelete(url, config)];
                        case 1:
                            resultData = _a.sent();
                            if (resultData && resultData.data) {
                                return [2, resultData.data];
                            }
                            return [2, resultData];
                    }
                });
            });
        };
        ServiceTransport.prototype.head = function (url, config) {
            if (config === void 0) { config = {}; }
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var resultData;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.executeHead(url, config)];
                        case 1:
                            resultData = _a.sent();
                            if (resultData && resultData.data) {
                                return [2, resultData.data];
                            }
                            return [2, resultData];
                    }
                });
            });
        };
        ServiceTransport.prototype.put = function (url, data, config) {
            if (config === void 0) { config = {}; }
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var resultData;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.executePut(url, config)];
                        case 1:
                            resultData = _a.sent();
                            if (resultData && resultData.data) {
                                return [2, resultData.data];
                            }
                            return [2, resultData];
                    }
                });
            });
        };
        ServiceTransport.prototype.patch = function (url, data, config) {
            if (config === void 0) { config = {}; }
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var resultData;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.executePatch(url, data, config)];
                        case 1:
                            resultData = _a.sent();
                            if (resultData && resultData.data) {
                                return [2, resultData.data];
                            }
                            return [2, resultData];
                    }
                });
            });
        };
        ServiceTransport.prototype.executeGet = function (url, config) {
            if (config === void 0) { config = {}; }
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.apiService.get(this.updateConfig(url), this.transportConfig(url, config))];
                        case 1: return [2, _a.sent()];
                    }
                });
            });
        };
        ServiceTransport.prototype.executePost = function (url, data, config) {
            if (config === void 0) { config = {}; }
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var executeParams;
                var _this = this;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            executeParams = data;
                            if (!(config && config.headers)) return [3, 1];
                            return [2, new Promise(function (resolve, reject) {
                                    _this.apiService({
                                        method: 'post',
                                        url: _this.updateConfig(url),
                                        data: executeParams,
                                        headers: (0, tslib_1.__assign)({}, config.headers),
                                        params: _this.getCustomParams(url, config)
                                    }).then(function (response) {
                                        resolve(response);
                                    }).catch(function (e) {
                                        resolve(e);
                                    });
                                })];
                        case 1: return [4, this.apiService.post(this.updateConfig(url), executeParams, this.transportConfig(url, config))];
                        case 2: return [2, _a.sent()];
                    }
                });
            });
        };
        ServiceTransport.prototype.executeDelete = function (url, config) {
            if (config === void 0) { config = {}; }
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.apiService.delete(this.updateConfig(url), this.transportConfig(url, config))];
                        case 1: return [2, _a.sent()];
                    }
                });
            });
        };
        ServiceTransport.prototype.executeHead = function (url, config) {
            if (config === void 0) { config = {}; }
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.apiService.head(this.updateConfig(url), this.transportConfig(url, config))];
                        case 1: return [2, _a.sent()];
                    }
                });
            });
        };
        ServiceTransport.prototype.executePut = function (url, data, config) {
            if (config === void 0) { config = {}; }
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.apiService.put(this.updateConfig(url), data, this.transportConfig(url, config))];
                        case 1: return [2, _a.sent()];
                    }
                });
            });
        };
        ServiceTransport.prototype.executePatch = function (url, data, config) {
            if (config === void 0) { config = {}; }
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.apiService.patch(this.updateConfig(url), data, this.transportConfig(url, config))];
                        case 1: return [2, _a.sent()];
                    }
                });
            });
        };
        return ServiceTransport;
    }(ServiceBase_1.BaseService));
    exports.ServiceTransport = ServiceTransport;
});
//# sourceMappingURL=ServiceTransport.js.map